import { render, staticRenderFns } from "./UserMessageBubble.vue?vue&type=template&id=c984c578&scoped=true&"
import script from "./UserMessageBubble.vue?vue&type=script&lang=js&"
export * from "./UserMessageBubble.vue?vue&type=script&lang=js&"
import style0 from "./UserMessageBubble.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserMessageBubble.vue?vue&type=style&index=1&id=c984c578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c984c578",
  null
  
)

export default component.exports